export default "__VITE_ASSET__1dfd942b__"